import React from 'react';
import Budget from '../office/Budget';

const StoreKeeperBudget: React.FC = () => {
  return <Budget />;
};

export default StoreKeeperBudget; 